import { render, staticRenderFns } from "./table-child.vue?vue&type=template&id=3c41fda7&"
import script from "./table-child.vue?vue&type=script&lang=ts&"
export * from "./table-child.vue?vue&type=script&lang=ts&"
import style0 from "./table-child.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports